import { render, staticRenderFns } from "./GoalTextInput.vue?vue&type=template&id=228ccb92&scoped=true&"
import script from "./GoalTextInput.vue?vue&type=script&lang=js&"
export * from "./GoalTextInput.vue?vue&type=script&lang=js&"
import style0 from "./GoalTextInput.vue?vue&type=style&index=0&id=228ccb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ccb92",
  null
  
)

export default component.exports